import {
  DashboardFilled,
  StarFilled,
  ProductFilled,
  GiftFilled,
  MessageFilled,
  ShopFilled
} from '@ant-design/icons';

const icons = {
  DashboardFilled,
  StarFilled,
  ProductFilled,
  GiftFilled,
  MessageFilled,
  ShopFilled
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //


const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardFilled,
      breadcrumbs: false,
    },
    {
      id: 'brand',
      title: 'Brands',
      type: 'item',
      url: '/brands',
      icon: icons.StarFilled,
      breadcrumbs: false,

    },
    {
      id: 'product',
      title: 'Products',
      type: 'item',
      url: '/products',
      icon: icons.ShopFilled,
      breadcrumbs: false,
    },
    {
      id: 'offer',
      title: 'Offers',
      type: 'item',
      url: '/offers',
      icon: icons.GiftFilled,
      breadcrumbs: false,
    },
    {
      id: 'testimonial',
      title: 'Testimonials',
      type: 'item',
      url: '/testimonials',
      icon: icons.MessageFilled,
      breadcrumbs: false,
    },
  ]
};


export default dashboard;
